module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/players-4a79763fb7bafaadab8079de4b10ff05.png";